import { MESSAGES } from 'src/modules/common/constants.ts';

export type FlowRangeFields = 'FlowRangeM3h' | 'FlowRangeLh' | 'FlowRangeLs' | 'FlowRangeGpm';

export const FlowUnitsOptions: [FlowRangeFields, string][] = [
    ['FlowRangeM3h', MESSAGES.CubicMeterPerHour],
    ['FlowRangeLh', MESSAGES.LiterPerHour],
    ['FlowRangeLs', MESSAGES.LiterPerSecond],
    ['FlowRangeGpm', MESSAGES.GallonsPerMinute],
];
